export const phoneRegExp = /\(?\d{2,}\)? ?\d{4,5}-?\d{4}/g;
export const cpfRegExp = /^\d{3}.\d{3}.\d{3}-\d{2}$/;
